import React from 'react';

import TableBody from './components/table-body';
import TableHeader from './components/table-header';

import type { TableProps } from './table.props';

import './table.scss';

const Table = ({
  headerItems,
  isProcessing,
  rows,
  tableType,
  onResetFilter,
  onSortByColumn,
}: TableProps) => {
  return (
    <table className="table">
      <TableHeader items={headerItems} tableType={tableType} onSortByColumn={onSortByColumn} />
      <TableBody
        isProcessing={isProcessing}
        rows={rows}
        tableType={tableType}
        onResetFilter={onResetFilter}
      />
    </table>
  );
};

export default Table;
